var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('mediator',{attrs:{"components":_vm.components,"hide-content":_vm.hideContent,"hide-delimiters":_vm.hideDelimiters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }